import { render, staticRenderFns } from "./TipComponent.vue?vue&type=template&id=781c0947&scoped=true&"
import script from "./TipComponent.vue?vue&type=script&lang=js&"
export * from "./TipComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c0947",
  null
  
)

export default component.exports